import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { ImportPortfolioNamesResultDialogComponent } from '@irb/irb-clients/import-portfolio-names-result-dialog/import-portfolio-names-result-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class ImportPortfolioNamesResultGridLayoutService implements GridLayoutService<ImportPortfolioNamesResultDialogComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [{
            headerName: 'Entity',            
            field: 'entity',
            maxWidth: 140,
            flex: 1,
            sort:'asc',
            cellRenderer: 'cellRendererFormatter'
        },
        {
            headerName: 'Error Condition',
            field: 'errorDesc',
            maxWidth: 331,
            flex: 3
        },
        {
            headerName: 'Line Number',
            field: 'lineNumber',
            maxWidth: 120,
            flex: 1
        }];
    }
}
